import { render, staticRenderFns } from "./CoinProduct.vue?vue&type=template&id=5514e5e5&scoped=true"
import script from "./CoinProduct.vue?vue&type=script&lang=ts"
export * from "./CoinProduct.vue?vue&type=script&lang=ts"
import style0 from "./CoinProduct.vue?vue&type=style&index=0&id=5514e5e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5514e5e5",
  null
  
)

export default component.exports